import { BottomNavigation, BottomNavigationAction, Paper, SvgIcon, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';

import EmailIcon from '@material-ui/icons/Email';


const styles = {
	flexSection: {
		display: 'flex',
		flexDirection: 'row' as any,
		flexGrow: 1,
		margin: '25px'
	},
	verticalFlex: {
		display: 'flex',
		flexDirection: 'column' as any,
		flexGrow: 1
	}
}
type Props = WithStyles & WithStyles<keyof typeof styles>;

export class Contact extends React.Component<Props, {}> {
	public componentDidMount() {
		const options = {
			chrome: 'noheader nofooter noborders noscrollbar transparent',
			height: '360px',
			linkColor: '#ed4a68',
			theme: 'dark'
		};
		const twitter: any = twttr;
		twitter.widgets.createTimeline(
			{
				screenName: 'newtindustries',
				sourceType: 'profile'
			},
			document.getElementById('twitterSection'),
			options
		);
		twitter.widgets.createTimeline(
			{
				screenName: 'risksystem_game',
				sourceType: 'profile'
			},
			document.getElementById('twitterSection2'),
			options
		);
	}
	public render() {
		const { classes } = this.props;
		return (
			<Paper color={'secondary'} style={{ color: '#f8f8f8', width: `${700}px`, background: `linear-gradient(to right, rgba(11, 11, 11, .8), rgba(11, 11, 11, 1) ${700 / 2}px, rgba(11, 11, 11, .8) ${700}px)`, backgroundSize: `${700}px 100%`, backgroundPosition: '50% 100%', backgroundRepeat: 'no-repeat', margin: '10px auto' }}>
				<div className={classes.verticalFlex}>
					<div style={{ display: 'flex' }}>
						<div className={classes.flexSection}>
							<div id={'twitterSection'} />
						</div>
						<div className={classes.flexSection}>
							<div id={'twitterSection2'} />
						</div>
					</div>
					<BottomNavigation style={{display: 'flex'}}>
						<BottomNavigationAction label="Email" icon={<EmailIcon />} showLabel={true} onClick={this.onEmailClick}/>
						<BottomNavigationAction label="Instagram" icon={this.getInstagramIcon()} showLabel={true} onClick={this.onInstagramClick} />
						<BottomNavigationAction label="Facebook" icon={this.getFacebookIcon()} showLabel={true} onClick={this.onFacebookClick} />
					</BottomNavigation>
				</div>
			</Paper>
		);
	}
	private onEmailClick() {
		location.href = 'mailto:info@newtindustries.com';
	}
	private onInstagramClick() {
		const win = window.open('https://www.instagram.com/newtistbeach', '_blank');
		if (win) {
			win.focus();
		}
	}
	private onFacebookClick() {
		const win = window.open('https://www.facebook.com/newtindustrieswi/', '_blank');
		if (win) {
			win.focus();
		}
	}
	private getFacebookIcon() {
		return (
			<SvgIcon>
				<path fill="currentColor" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
			</SvgIcon>
			);
	}
	private getInstagramIcon() {
		return (
			<SvgIcon>
				<path fill="currentColor" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
			</SvgIcon>
		);
	}
}

export default withStyles(styles)(Contact);


// WEBPACK FOOTER //
// ./src/components/Contact.tsx